import { MergeDataset, MergeSource } from '../../decorators';;
import { ActivityEntityName, DocumentTheme, DocumentThemeQuoteOptions } from '../../../../entities';
import { CompanyMergeData, CompanyMergeSchema, EmployeeMergeData, EmployeeMergeSchema, QuoteProMergeSchema, QuoteProMergeData, AccountMergeSchema, AccountContactMergeData, AccountContactMergeSchema, AccountMergeData, BasicSiteMergeSchema, BasicSiteMergeData } from '../data';

@MergeDataset({
    entity: ActivityEntityName.QuotePro,
    dependsOn: [ActivityEntityName.Job, ActivityEntityName.Opportunity]
})
@MergeDataset({
    entity: ActivityEntityName.Quote,
    dependsOn: [ActivityEntityName.Job, ActivityEntityName.Opportunity]
})
export class QuoteProMergeDataset {

    @MergeSource({
        schema: QuoteProMergeSchema
    })
    quote: QuoteProMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    quoteOwner: EmployeeMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    quoteCompany: CompanyMergeData;

    @MergeSource({
        schema: AccountMergeSchema
    })
    quoteAccount: AccountMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    quoteSite: BasicSiteMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    quoteContact: AccountContactMergeData;

    theme: DocumentTheme<DocumentThemeQuoteOptions>;

    public static get empty() {
        return {
            quote: new QuoteProMergeData(),
            quoteOwner: new EmployeeMergeData(),
            quoteContact: new AccountContactMergeData(),
            quoteAccount: new AccountMergeData(),
            quoteSite: new BasicSiteMergeData(),
            quoteCompany: new CompanyMergeData(),
            theme: null
        } as QuoteProMergeDataset;
    }
}